export default __webpack_public_path__ + "static/media/0044.af98e9a4.png";